import React from "react";

const ClearInputBox = ({ value, onChange, placeholder = "" }) => {
    const isActive =
        value !== "" && value !== null && value !== undefined;

    const baseBorderColor = "#cdcbcbff";
    const activeBorderColor = "#446E9B";
    const borderColor = isActive ? activeBorderColor : baseBorderColor;

    const handleClear = (e) => {
        e.stopPropagation();
        // Fake a normal input event so parent can still do: onChange("FIELD", e.target.value)
        const eventLike = { target: { value: "" } };
        onChange(eventLike);
    };

    return (
        <div className="position-relative w-100">
            <div
                className="d-flex w-100"
                style={{
                    border: `2px solid ${borderColor}`,
                    borderRadius: "4px",
                    overflow: "hidden", // same as SelectDropDownContext
                }}
            >
                {/* Actual text input */}
                <input
                    type="text"
                    className="form-control form-control-sm border-0 shadow-none bg-white"
                    style={{
                        minHeight: "33px",
                        fontSize: "0.8rem",
                        fontWeight: 400,
                        borderRadius: 0, // wrapper owns radius
                    }}
                    value={value}
                    placeholder={placeholder}
                    onChange={onChange}
                />

                {/* X clear button */}
                <button
                    type="button"
                    className={`btn btn-sm border-0 shadow-none bg-white ${isActive ? "text-muted" : "text-white"}`}
                    style={{
                        minWidth: "32px",
                        borderRadius: 0, // wrapper owns radius
                    }}
                    disabled={!isActive}
                    onClick={handleClear}
                >
                    X
                </button>
            </div>
        </div>
    );
};

export default ClearInputBox;
